import CollectionDataSource from '../../dao/DataSource/CollectionDataSource';
import ModalBannerConstants from '../../constants/ModalBannerConstants';
import dataModel from '../../models/DataModel';
import _ from 'lodash';

const unreadAnnouncementDescriptor = { 
  announcement: {
  },
};

class UnreadAnnouncements {
  
  constructor() {
    this.firstTime = false;
    this.unreadAnnouncements = null;
    this.unreadAnnouncementsDataSource = null;
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.markRead = this.markRead.bind(this);
    this.showNextAnnouncement = this.showNextAnnouncement.bind(this);
    this.handleUpdateUnreadAnnouncements = this.handleUpdateUnreadAnnouncements.bind(this);
  }
  
  start() {
    if (!dataModel.mobileBridge.isMobile) {
      this.stop();
      this.firstTime = true;
      this.unreadAnnouncementsDataSource = new CollectionDataSource('UnreadAnnouncementsCollection', 'Announcement', unreadAnnouncementDescriptor, this.handleUpdateUnreadAnnouncements);
      this.unreadAnnouncementsDataSource.current();
    }
  }

  stop() {
    if (this.unreadAnnouncementsDataSource) {
      this.unreadAnnouncementsDataSource.release();
      this.unreadAnnouncementsDataSource = null;
    }
    this.firstTime = false;
  }

  markRead(announcementId) {
    const index = this.unreadAnnouncements.findIndex(announcement => announcement.id == announcementId);
    if (index >= 0) {
      const announcement = this.unreadAnnouncements[index];
      announcement.showing = true;
      dataModel.announcementsDAO.markRead(announcement).then((result) => {
      });
    }
  }

  handleUpdateUnreadAnnouncements(unreadAnnouncements, action, acData, fetchedData) {
    if (action == 'prefetch') {
    }
    else if (unreadAnnouncements) {
      // merge only "new" announcements
      this.unreadAnnouncements = _.unionBy(unreadAnnouncements.announcements, this.unreadAnnouncements, 'id');
      this.showNextAnnouncement();
    }
  }

  showNextAnnouncement(announcementId) {
    if (announcementId) {
      const index = this.unreadAnnouncements.findIndex(announcement => announcement.id == announcementId);
      if (index >= 0) {
        this.unreadAnnouncements.splice(index, 1);
      }
    } 
    if (this.unreadAnnouncements.length > 0) {
      const showing = this.unreadAnnouncements.find(announcement => announcement.showing);
      if (!showing) {
        setTimeout(() => {
          // display first announcement only (for now)...
          dataModel.showGlobalBanner(ModalBannerConstants.ANNOUNCEMENT_BANNER, {
            announcement_text: this.unreadAnnouncements[0].announcement_text,
            className: 'announcement-banner',
            announcementId: this.unreadAnnouncements[0].id,
          });
        }, this.firstTime ? 5000 : 1000);
        this.firstTime = false;
      }
    }
  }

}

export default new UnreadAnnouncements();



// WEBPACK FOOTER //
// ./src/helpers/Announcements/UnreadAnnouncements.js